import koponsLst from "../_ApiConn/apiKopons";


const chekckKopon = async (kopon, order) => {
    const token = localStorage.getItem('usrtoken');
    let dFromF = await koponsLst.chekckKopon({ token, kopon, order });
    return (dFromF);
}

const reserveKopon = async (koponId) => {
    const token = localStorage.getItem('usrtoken');
    let dFromF = await koponsLst.reserveKopon({ token, koponId });
    return (dFromF);
}

const releaseKoponReservation = async (koponId, reservationToken) => {
    const token = localStorage.getItem('usrtoken');
    let dFromF = await koponsLst.releaseKoponReservation({ token, koponId, reservationToken });
    return (dFromF);
}


export default {
    chekckKopon,
    reserveKopon,
    releaseKoponReservation
};